<template>
  <Modal v-model="modalValue" title="审核" width="500" @on-cancel="modalCancel">
    <Row>
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="审核状态" prop="status">
            <Select v-model="form.status" @on-change="statusChange">
              <Option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.value"></Option>
            </Select>
          </FormItem>
          <FormItem label="审核意见" prop="remark">
            <Input type="textarea" placeholder="请输入审核意见" v-model="form.remark"></Input>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import * as apiMember from '@/api/member'
  export default {
    name: 'add-card',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      // 类型1个人，2单位，3职位
      type: {
        type: [Number, String],
        default: 1,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        btnLoading: false,
        form: {
          status: '',
          remark: '',
        },
        statusList:[
          // { name:'通过待缴会费',value:"1" },
          { name:'驳回未通过',value:"2" },
          { name:'入会成功',value:"3" },
        ],
        rules: {
          status: [{ required: true, message: '审核状态不能为空', trigger: 'change' }],
          remark: [{ required: true, message: '审核意见不能为空', trigger: 'blur' }],
        },
      }
    },
    methods: {
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            let fn = ''
            if (this.type == 1) {
              fn = apiMember.apiPersonMemberRemark(this.id, this.form)
            } else if(this.type == 2){
              fn = apiMember.apiCompanyMemberRemark(this.id, this.form)
            }else if(this.type == 3){
              fn = apiMember.apiPositionRemark(this.id, this.form)
            }
            fn.then(res => {
              this.$Message.success('审核成功')
                this.$emit('on-success')
                this.modalCancel()
            }).finally(() => this.btnLoading = false)
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
      statusChange(e) {
        if(e == 1 || e == 3) {
          this.form.remark = this.statusList.find(item => item.value == e).name
        } else {
          this.form.remark = ''
        }
      }
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
  }
</script>
